import React from 'react'
import FontFile from '../shared/font-file'


// Layered: base span = Shadow family in backCol, overlay span = Face family in mainCol.
const Word = (props) => {
  return <FontFile
    font={'signwriter'}
    overlayFont={'signwriter-back'}
    topOffset='0.15em'
    multiplier={1}
    {...props}
    borderColor={props.backCol}

    emojiOffset={-0.1}
    emojiMultiplier={1.1}
  />
}

export default Word
